export const getGatsbyStaticImageObj = (src) => {
    return {
        aspectRatio: 1.7777777777777777,
        presentationHeight: 1080,
        presentationWidth: 1920,
        sizes: '(max-width: 1920px) 100vw, 1920px',
        src,
        srcSet: `${src} 200w,${src} 400w,${src} 600w,${src} 800w,${src} 1920w`,
        tracedSVG: undefined,
    }
}

export const constructImage = (file) => {
    const baseUrl = process.env.GATSBY_CLOUDINARY_IMAGE_URL
    const transform = 'q_auto,f_auto/' // https://cloudinary.com/blog/image_optimization_for_websites_beautiful_pages_that_load_quickly
    const filepath = file.filepath + file.filename.replace(/[(]/g, '_').replace(/[)]/g, '')
    const ending = transform + filepath
    const fileExtension = filepath.split('.').pop()

    const selection = {
        thumb: baseUrl + 'w_320,' + ending,
        small: baseUrl + 'w_640,' + ending,
        medium: baseUrl + 'w_1280,' + ending,
        large: baseUrl + 'w_1920,' + ending,
        original: baseUrl + ending,
    }
    const srcset = [
        `${selection.thumb} 320w`,
        `${selection.small} 640w`,
        `${selection.medium} 1280w`,
        `${selection.large} 1920w`,
        `${selection.original} 2560w`,
    ]

    return {
        fileExtension,
        selection,
        srcset: srcset.join(),
    }
}

export const stripHtmlTags = (html, keepParagraphs = true) => {
    let sanitisedContent
    if (keepParagraphs) {
        sanitisedContent = html.replace(/<(?!br|\/br|p|\/p).+?>/g, '')
    } else {
        sanitisedContent = html.replace(/<.+?>/g, '')
    }
    return sanitisedContent
}
